import { useSelector } from 'react-redux'
import { RaychatLogo } from 'app/components/icons'
import { getNormalizedUrl } from 'app/utils/links'
import styles from './styles.module.scss'
import clsx from 'clsx'

const getCoverIcon = ({ widgetData }) => widgetData.widgetInfo.data.coverIcon
const getCustomLogo = ({ widgetData }) => widgetData.widgetInfo.data.personalize.isCustomLogo

// logo used in cover and departments list section
function CoverLogo({ customClass }) {
  const coverIcon = useSelector(getCoverIcon)
  const customLogo = useSelector(getCustomLogo)

  // do not show if icon is set as sleep logo or default launcher icon
  const getCoverLogo = () => {
    if (coverIcon && !coverIcon.endsWith('logos/v2/1.svg') && !coverIcon.includes('raychat-logo-sleep')) {
      return coverIcon
    }

    return customLogo ? getNormalizedUrl(customLogo) : ''
  }

  const coverLogo = getCoverLogo()

  if (coverLogo) {
    return <img className={clsx(styles.logo, customClass)} src={coverLogo} alt="" />
  }

  return <RaychatLogo className={clsx(styles.default_logo, customClass)} />
}

export default CoverLogo
